export const CustomParamsHashmap = {
  default: ['first_name', 'your_name', 'last_name', 'discount_code', 'tracking_link'],
  approval: [
    'first_name',
    'last_name',
    'email',
    'discount_code',
    'tracking_link',
    'brand_name',
    'your_name',
    'login_email',
    'password',
    'dashboard_link',
  ],
  dashboardCredentials: ['first_name', 'brand_name', 'your_name', 'login_email', 'password', 'dashboard_link'],
  rejection: ['first_name', 'brand_name', 'your_name'],
  inboundReminder: ['ambassador_page_link', 'brand_name', 'your_name'],
  usageRights: ['first_name', 'user_name'],
};
